export default class CopyToClipboard {
    constructor() {
        this.copyTriggers = document.querySelectorAll('[data-copy-to-clipboard-text]');
        this.addEventListeners();
    }
    addEventListeners() {
        this.copyTriggers.forEach((trigger) => {
            trigger.addEventListener('click', (event) => {
                event.preventDefault();
                const currentTarget = event.currentTarget;
                const data = currentTarget.getAttribute('data-copy-to-clipboard-text');
                this.handleCopy(data, currentTarget);
            });
        });
    }
    handleCopy(data, target) {
        if (!data)
            return;
        navigator.clipboard.writeText(data).then(() => {
            if (target) {
                target.classList.add('copied');
                setTimeout(() => target.classList.remove('copied'), 1500);
            }
        }).catch(err => {
            console.error('Copy failed', err);
        });
    }
}
